export const SET_LOADING_OVERLAY_IS_ACTIVE = "global/SET_LOADING_OVERLAY_IS_ACTIVE";
export const setLoadingOverlayIsActive = (isActive) => ({
  type: SET_LOADING_OVERLAY_IS_ACTIVE,
  payload: {
    isActive,
  },
});

const INITIAL_STATE = {
  loadingOverlayIsActive: false,
};

const getState = (state) => state.sharedState;
export const getLoadingOverlayIsActive = (state) =>
  getState(state).loadingOverlayIsActive;

const reducer = (state = INITIAL_STATE, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_LOADING_OVERLAY_IS_ACTIVE:
      return {
        ...state,
        loadingOverlayIsActive: payload.isActive,
      };
    default:
      return state;
  }
};

export default reducer;
